import { User, UserRole } from 'models/user.model';
import apiClient from 'api/base';

export const getAdmins = async (): Promise<User[]> => {
  const { data } = await apiClient.get('/admins');

  return data;
};

export const inviteAdmin = async (
  email: string,
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.post('/admins', { email, role });

  return data;
};

export const inviteAdminInBulk = async (
  emails: string[],
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.post('/admins/bulk', { emails, role });

  return data;
};

export const updateAdminRole = async (
  adminId: string,
  role: UserRole,
): Promise<void> => {
  const { data } = await apiClient.patch(`/admins/${adminId}/role`, { role });

  return data;
};

export const deleteAdmin = async (adminId: string): Promise<void> => {
  const { data } = await apiClient.delete(`/admins/${adminId}`);

  return data;
};
